import { Route as rootRoute } from './routes/__root'
import { Route as IndexRoute } from './routes/index'
import { Route as ChatbotRoute } from './routes/chatbot'
import { Route as FnaRoute } from './routes/fna'
import { Route as LoginRoute } from './routes/login'
import { Route as LogsRoute } from './routes/logs'

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  ChatbotRoute,
  FnaRoute,
  LoginRoute,
  LogsRoute,
])
